/**
 * teeinblue-gallery-fix.js
 * TeeinBlue-Galerie bleibt im Horizon-Theme bei Variantenwechsel erhalten.
 * media-gallery.js #handleVariantUpdate ruft this.replaceWith(newMediaGallery)
 * und wirft dabei TeeinBlues .tee-gallery-content raus. Wir neutralisieren
 * replaceWith NUR auf TeeinBlue-Produkten. Preis/Verfuegbarkeit/ATC/Variant-
 * Picker laufen ueber andere Listener und bleiben unberuehrt.
 */
(function () {
  if (window.__teeinblueGalleryLockInstalled) return;
  window.__teeinblueGalleryLockInstalled = true;

  var LOCK = '__teeinblueLocked';

  function isTeeinblueProduct() {
    try {
      if (window.teeinblueCampaign && window.teeinblueCampaign.isTeeInBlueProduct) return true;
    } catch (e) {}
    return !!(
      document.querySelector('media-gallery .tee-gallery-content') ||
      document.querySelector('.tee-gallery-wrapper')
    );
  }

  function lockGallery(mg) {
    if (!mg || mg[LOCK]) return;
    mg[LOCK] = true;
    // Horizon: media-gallery.js #handleVariantUpdate -> this.replaceWith(newMediaGallery)
    mg.replaceWith = function () { /* no-op: keep TeeinBlue gallery */ };
  }

  function tryLock() {
    if (!isTeeinblueProduct()) return false;
    var mg = document.querySelector('media-gallery');
    if (mg) { lockGallery(mg); return true; }
    return false;
  }

  if (!tryLock()) {
    var obs = new MutationObserver(function () {
      var mg = document.querySelector('media-gallery');
      if (mg && !mg[LOCK] && isTeeinblueProduct()) lockGallery(mg);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 20000);
  }
})();